module.exports = __webpack_public_path__ + "img/gastro-schwein.de84e4a0.jpg";